import { Skeleton } from '@mui/material';
import './NotesForEntity.scss';
import { SkeletonButton } from 'app/agriculture/components/Button/SkeletonButton';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';

export function NotesForEntitySkeleton() {
    return (
        <ContentBox.Section disableDivider>
            <div className="latest-note-container">
                <label className="stat-display-name">Latest Note</label>
                <div className="latest-note-header">
                    <Skeleton variant="text" width={80} />
                    <Skeleton variant="text" width={80} />
                </div>
                <div className="latest-note-text">
                    <Skeleton variant="text" />
                </div>
                <SkeletonButton />
            </div>
        </ContentBox.Section>
    );
}
